import { bl_mlm_entity_contact_hdr_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";


export class MlmEntityContactContainerModel extends BaseContainerModel {

    bl_mlm_entity_contact_hdr : bl_mlm_entity_contact_hdr_RowClass = new bl_mlm_entity_contact_hdr_RowClass();
}